import * as actionTypes from "./actionTypes";

export const actions = {
  getLGL: () => ({ type: actionTypes.GET_LGL_REQ }),
  getLGLSuccess: (payload) => ({
    type: actionTypes.GET_LGL_SUCCESS,
    payload,
  }),
  getLGLFail: (error) => ({
    type: actionTypes.GET_LGL_FAIL,
    error: error?.response?.data?.error,
  }),
};

const initialState = {
  data: {
    currentLevel: {},
    nextLevelToShow: {},
    inCompleteLevels: {},
    widget: {},
    blacklisted: false,
  },
  error: "",
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_LGL_SUCCESS:
      return {
        error: "",
        data: { ...action.payload },
      };
    case actionTypes.GET_LGL_FAIL:
      return {
        data: {},
        error: action.payload,
      };
    default:
      return state;
  }
};
reducer.initialState = initialState;
export default reducer;
